import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import {
  AllocationViewRegisterNewTruckAction,
  AllocationViewRegisterNewTruckSetInitialState,
} from './allocation-view-register-new-truck-action.actions';
import { AllocationViewRegisterNewTruckActionService } from './allocation-view-register-new-truck-action.service';

export interface AllocationViewRegisterNewTruckActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewRegisterNewTruckActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsRegisterNewTruck',
  defaults: initialState,
})
@Injectable()
export class AllocationViewRegisterNewTruckActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewRegisterNewTruckActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewRegisterNewTruckActionService: AllocationViewRegisterNewTruckActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewRegisterNewTruckAction)
  registerNewTruck(
    ctx: StateContext<AllocationViewRegisterNewTruckActionStateModel>,
    { payload: { identifier } }: AllocationViewRegisterNewTruckAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewRegisterNewTruckActionService.registerNewTruck(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.registerST');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewRegisterNewTruckSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewRegisterNewTruckActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
